enum AttributeTypeEnum {
    TEXT = "text",
    NUMBER = "number",
    DROPDOWN = "dropdown",
    BOOLEAN = "boolean",
    DATE = "date",
}

export default AttributeTypeEnum;
